// EVERY CALENDAR IN THE PORTAL STARTS ITS WEEK ON MONDAY.
//
// Both date libraries ship an American default — the calendar grid opens on
// Sunday — and the portal is read by people who write the week down starting
// on Monday. This module is imported once, for its side effects, before
// anything renders.
//
// It is done here rather than at the call sites because there are two
// different stacks and a great many of them:

import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import { setDefaultOptions } from 'date-fns';
import { enUS } from 'date-fns/locale';

// 1. antd — the DatePicker and RangePicker the filter bars use (twenty-odd
//    toolbars, plus the shared components/DateRangeFilter).
//
//    antd asks the DAYJS locale which day the week starts on, and its
//    default resolves to plain 'en', which answers Sunday. Moving that one
//    answer moves every antd calendar in the portal at once.
//
//    Only the week start is changed — not the date format, which several
//    toolbars set for themselves and which must keep reading the way it
//    reads today.
dayjs.extend(updateLocale);
dayjs.updateLocale('en', { weekStart: 1 });

// 2. MUI — the pickers inside the forms. There are TWO of these, not one,
//    and they need different levers:
//
//    a. `@mui/x-date-pickers` 6 at the top level (52 imports). Its adapter
//       defaults to date-fns' own `enUS` and passes it down, so moving that
//       one object's week start moves every picker built on it.
if (enUS.options) {
  enUS.options.weekStartsOn = 1;
}

//    b. `@mui/lab` — which is where 244 of the app's pickers come from,
//       DesktopDatePicker included. It carries its own nested
//       x-date-pickers 5.0.0-alpha.0, whose "AdapterDateFns" is not MUI's at
//       all: it re-exports `@date-io/date-fns`, and that one keeps
//       `this.locale = locale` — UNDEFINED, because none of the call sites
//       name a locale — and then calls `startOfWeek(value, { locale:
//       undefined })`. The enUS object above is never consulted on this
//       path, which is why fixing (a) alone left every lab picker on Sunday.
//
//       date-fns resolves that undefined case against its own default
//       options, so this is the lever that reaches it. getWeekdays (the
//       column letters) and getWeekArray (the grid) both go through
//       startOfWeek, so one setting moves the header and the days together.
//
//       Only `weekStartsOn` is set — not `locale`, which would change how
//       dates FORMAT. It is read by startOfWeek/endOfWeek/getWeek and their
//       kin, and no code in this app calls any of them: the week-boundary
//       reports are written with moment, which keeps its own locale data and
//       is untouched by this file. So the blast radius really is the
//       calendar grid.
setDefaultOptions({ weekStartsOn: 1 });
